export enum routes {
  ABOUT = '/about',
  INDEX_HTML = '/index.html',
  PUBLIC_ROOM = '/public/:roomId',
  ROOT = '/',
  SETTINGS = '/settings',
}
